<template>
  <div class="payment">
    <form-layout
      :main-title="title"
      :mobile-title="mobileTitle"
      :small-title="true"
      :title="title"
      :sub-title="$t('transfer.paymentSubTitle')"
      @back="goToTransferInstruction"
      @submit="changeModal"
    >
      <div v-if="!isGiftMethod" class="payment__main">
        <div class="payment__info">
          <Input
            v-model="data.nickname"
            :disabled="true"
            icon="/base/user.svg"
            :placeholder="$t('transfer.nickname')"
          />
          <Input
            :value="data.totalRobux + ' R$'"
            :disabled="true"
            icon="/base/robux.svg"
            :placeholder="$t('transfer.nickname')"
            :bonus="$store.state.promoCode.bonus ? `+${$store.state.promoCode.bonus} R$` : null"
          />
          <Input
            :value="data.moneyTotal().toFixed(2) + ` ${currencyMap[$store.state.currency]}`"
            :disabled="true"
            icon-text="₽"
            :placeholder="$t('transfer.nickname')"
          />
        </div>
        <Alert state="warning" :title="$t('general.warning')" :info="alertInfo" />

        <p class="payment__main__result">
          {{ $t('payment.toPay') }}:
          <span>
            {{ data.moneyTotal().toFixed(2) }}
            {{ currencyMap[$store.state.currency] }}
          </span>
        </p>
      </div>
      <div v-else class="payment__main">
        <div class="payment__info">
          <Input :value="data.gift.quantity + ' R$'" :disabled="true" icon="/base/robux.svg" />
          <Input
            :value="gift.price && gift.price.rub + ` ${currencyMap[$store.state.currency]}`"
            :disabled="true"
            icon-text="₽"
          />
        </div>

        <Alert
          class="payment__alert--gift"
          state="warning"
          :title="$t('general.warning')"
          :info="$t('gift.infoText')"
        />

        <!--        <p class="payment__main__result">
          {{ $t('payment.toPay') }}:
          <span>
            {{ gift.price && gift.price.rub }}
            {{ currencyMap[$store.state.currency] }}
          </span>
        </p>-->
      </div>
    </form-layout>
  </div>
</template>

<script>
import FormLayout from '@/components/Base/FormLayout/FormLayout.vue'
import Input from '@/components/Base/Input/Input.vue'

import Alert from '@/components/Base/Alert/Alert.vue'

export default {
  name: 'OrderConfirmation',
  props: ['data'],
  inject: ['currencyMap'],
  components: {
    Input,
    FormLayout,
    Alert
  },
  data() {
    return {
      hint: false
    }
  },
  computed: {
    isGiftMethod() {
      return this.data.gift.quantity
    },
    gift() {
      return this.data.gift
    },
    title() {
      return this.isGiftMethod ? this.$t('gift.title') : this.$t('transfer.title')
    },
    mobileTitle() {
      return this.isGiftMethod ? this.$t('gift.title') : this.$t('transfer.titleMobile')
    },
    alertInfo() {
      return this.$t('transfer.subTitle')
    }
  },
  methods: {
    changeModal() {
      let emitParams = {}
      emitParams = {
        modal: !this.$store.state.isAuth ? 'SignIn' : 'TransferApproved'
      }

      if (this.$store.state.isAuth) this.$analytics.send('purch_trans_5_payment_balance', {})

      if (this.isGiftMethod) {
        if (!this.$store.state.isAuth) this.$emit('changeModal', emitParams)
        this.sendGift()
        return
      }

      this.$emit('changeModal', emitParams)
    },
    goToTransferInstruction() {
      const modal = this.isGiftMethod ? 'MainForm' : 'TransferPrivatPlace'
      this.$emit('changeModal', {
        modal
      })
    },
    showHint() {
      this.$store.dispatch('notification/setNotification', {
        title: this.$t('general.success'),
        description: this.$t('transfer.gamepass.successHint'),
        type: 'success'
      })
    },
    async sendGift() {
      const { quantity, platform, category } = this.gift

      const requestHeaders = new Headers({
        Authorization: `Bearer ${this.$cookies.get('access_token')}`
      })

      try {
        const response = await fetch(
          `https://transfer.backend-pier.com/make_key_order?quantity=${quantity}&platform=${platform}&category=${category}`,
          { method: 'GET', headers: requestHeaders }
        )
        const data = await response.json()

        if (data.status) {
          this.$analytics.send('purch_gift_2_payment_balance', {})
          this.$store.dispatch('authorization', this.$cookies.get('access_token'))
          this.$router.push({ name: 'History', query: { method: 'gifts' } })
        } else {
          this.$store.dispatch('notification/setNotification', {
            title: this.$t('general.warning'),
            description: data.message || this.$t('payment.errors.server'),
            type: 'error'
          })
        }
      } catch (err) {
        console.log(err)
        this.$store.dispatch('notification/setNotification', {
          title: this.$t('general.warning'),
          description: this.$t('payment.errors.server'),
          type: 'error'
        })
      }
    }
  },
  mounted() {
    if (this.$store.state.isScipGamepass) {
      this.showHint()
    }
  }
}
</script>

<style lang="scss">
@import './orderConfirmation';
</style>
